import React, {Component} from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import MapboxLanguage from "@mapbox/mapbox-gl-language";
import Button from "@material-ui/core/Button";
import {SHOW_RESULT_LABEL} from "../../text";

const pitch = 15;
const cartoURL = process.env.REACT_APP_CARTO_URL;
const CelesteMapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

class CelesteMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapIsLoaded: null,
            popup: null
        };
    }

    componentDidMount() {

        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
        this.map = new mapboxgl.Map({
            container: "celeste-map",
            style: "mapbox://styles/mapbox/streets-v9",
            center: [2, 47],
            zoom: 5.6,
            maxZoom: 18
        });

        this.map.on("load", () => {
            this.map.fitBounds([-5.4534286, 41.2632185, 9.8678344, 51.268318], {
                animate: true
            });
            this.map.addLayer({
                id: "marker-click",
                type: "symbol",
                source: {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: []
                    }
                },
                layout: {
                    "icon-image": "{icon}-15",
                    "icon-allow-overlap": true
                }
            });

            this.setState({mapIsLoaded: true});
        });

        this.map.on("error", error => {
            this.props.handleAreSourcesLoaded(true);
        });

        this.map.on("click", e => {
            if (this.map.getZoom() >= process.env.REACT_APP_MIN_ZOOM_CLICK) {

                this.props.handleSetPosition({
                    lat: e.lngLat.lat,
                    lon: e.lngLat.lng
                });

                this.props.OpenModalAddress({
                    lat: e.lngLat.lat,
                    lon: e.lngLat.lng
                });
            }
        });

        this.map.addControl(new MapboxLanguage());
        this.map.addControl(new mapboxgl.NavigationControl());
    }

    relocate = () => {

        const location = this.props.getInitialPosition()

        if (location && this.state.lastLocation !== location) {

            this.updateLayerMarkerSource({
                type: "FeatureCollection",
                features: [
                    {
                        type: "Feature",
                        properties: {
                            icon: "marker"
                        },
                        geometry: {
                            type: "Point",
                            coordinates: [
                                location.lon,
                                location.lat
                            ]
                        }
                    }
                ]
            });

            const mapCenter = this.map.getCenter();

            if (location.lon && location.lat) {
                if (!this.state.lastLocation || mapCenter.lng !== location.lon || mapCenter.lat !== location.latZ) {

                    this.map.flyTo({
                        center: [
                            location.lon,
                            location.lat
                        ],
                        zoom: process.env.REACT_APP_ZOOM_GEOLOCATION,
                        speed: 1.3,
                    });
                    this.setState({
                        lastLocation: location,
                    });
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {mapIsLoaded} = this.state;
        const {geojson} = this.props;
        if (
            (prevProps.geojson === null && geojson !== null && mapIsLoaded) ||
            (prevProps.geojson !== null &&
                !prevState.mapIsLoaded &&
                mapIsLoaded &&
                geojson.layers)
        ) {
            this.map.addSource("vector-source", {
                type: "vector",
                url: `${cartoURL}/zones.json`
            });

            this.map.addSource("batiments", {
                type: "vector",
                url: `${cartoURL}/batiments.json`
            });

            let labelLayerId = this.map
                .getStyle()
                .layers.find(
                    layer => layer.type === "symbol" && layer.layout["text-field"]
                ).id;

            this.map.addLayer(
                {
                    id: "batiments",
                    source: "batiments",
                    "source-layer": "batiments",
                    type: "fill-extrusion",
                    minzoom: 15,
                    paint: {
                        "fill-extrusion-color": this.buildingColors(geojson.layers),
                        "fill-extrusion-height": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            15,
                            0,
                            15.05,
                            ["get", "height"]
                        ],
                        "fill-extrusion-base": [
                            "interpolate",
                            ["linear"],
                            ["zoom"],
                            15,
                            0,
                            15.05,
                            ["get", "min_height"]
                        ],
                        "fill-extrusion-opacity": 1,
                        "fill-extrusion-translate": [1, 2]
                    }
                },
                labelLayerId
            );

            if (geojson && geojson.layers) {
                geojson.layers.forEach(layer => {
                    this.map.addLayer(
                        {
                            id: layer.id + "-vector",
                            source: "vector-source",
                            "source-layer": layer.id,
                            type: "fill",
                            layout: {
                                visibility: layer.visibility ? "visible" : "none"
                            },
                            paint: {
                                "fill-color": "rgb(" + layer.color.slice(0, 3).join(", ") + ")",
                                "fill-outline-color": "rgba(0, 0, 0, 0)",
                                "fill-opacity": [
                                    "case",
                                    ["==", ["get", "class"], 1],
                                    0.12,
                                    ["==", ["get", "class"], 2],
                                    0.23,
                                    ["==", ["get", "class"], 3],
                                    0.33,
                                    ["==", ["get", "class"], 4],
                                    0.39,
                                    0
                                ]
                            },
                            minzoom: 10,
                            maxzoom: layer.maxzoomVector
                        },
                        "batiments"
                    );

                    this.map.addSource(layer.id + "-raster-source", {
                        type: "raster",
                        tiles: [cartoURL + "/rastertiles/" + layer.id + "/{z}/{x}/{y}.png"],
                        scheme: "tms",
                        tileSize: 256
                    });

                    this.map.addLayer({
                        id: layer.id + "-raster",
                        source: layer.id + "-raster-source",
                        type: "raster",
                        layout: {
                            visibility: layer.visibility ? "visible" : "none"
                        },
                        maxzoom: 10
                    });
                });
            }
            this.props.handleAreSourcesLoaded(true);
        }

        if (prevProps.geojson && geojson && geojson.layers) {
            let shouldUpdateMap = false;
            geojson.layers.forEach((layer, index) => {
                if (layer.visibility !== prevProps.geojson.layers[index].visibility) {
                    shouldUpdateMap = true;
                    if (layer.visibility) {
                        this.map.setLayoutProperty(
                            layer.id + "-raster",
                            "visibility",
                            "visible"
                        );
                        this.map.setLayoutProperty(
                            layer.id + "-vector",
                            "visibility",
                            "visible"
                        );
                    } else {
                        this.map.setLayoutProperty(
                            layer.id + "-raster",
                            "visibility",
                            "none"
                        );
                        this.map.setLayoutProperty(
                            layer.id + "-vector",
                            "visibility",
                            "none"
                        );
                    }
                }
            });
            if (shouldUpdateMap) {
                this.map.setPaintProperty(
                    "batiments",
                    "fill-extrusion-color",
                    this.buildingColors(geojson.layers)
                );
            }
        }
        if (
            !this.props.confirmedAddress &&
            prevProps.confirmedAddress &&
            this.popup
        ) {
            this.popup.remove();
        }

        if (this.props.sourcesAreLoaded) {
            this.relocate();
        }
    }

    updateLayerMarkerSource(source) {
        if (this.map.getLayer("marker-click")) {
            this.map.getSource("marker-click").setData(source);

            const customPopup = document.createElement("div");
            ReactDOM.render(
                <Button onClick={() => this.props.OpenModalResult()} variant="contained" style={{ backgroundColor: '#006eb7', margin:'5px', color:'white'}}>
                    {SHOW_RESULT_LABEL}
                </Button>,
                customPopup
            );

            if (source.features[0].geometry.coordinates[0] && source.features[0].geometry.coordinates[1]) {
                if (this.popup && this.popup.isOpen()) {
                    this.popup
                        .setLngLat([
                            source.features[0].geometry.coordinates[0],
                            source.features[0].geometry.coordinates[1]
                        ])
                        .setDOMContent(customPopup);
                } else {
                    this.popup = new mapboxgl.Popup({
                        closeOnClick: false,
                        closeButton: true
                    })
                        .setLngLat([
                            source.features[0].geometry.coordinates[0],
                            source.features[0].geometry.coordinates[1]
                        ])
                        .setDOMContent(customPopup)
                        .addTo(this.map);

                    this.popup.on("close", e => {
                        this.props.resetSearch();
                    });
                }
            }
        }
    }

    blendColors(colors) {
        let base = [...colors.shift()];
        /*    if (typeof base[3] === "undefined") {
                base[3] = 0.2;
            }*/
        let mix = base;
        let added = [];
        for (added of colors) {
            /* if (typeof added[3] === "undefined") {
                 added[3] = 0.2;
             }*/
            // check if both alpha channels exist.
            if (base[3] && added[3]) {
                mix = [0, 0, 0, 0];
                // alpha
                mix[3] = 1 - (1 - added[3]) * (1 - base[3]);
                // red
                mix[0] = Math.round(
                    (added[0] * added[3]) / mix[3] +
                    (base[0] * base[3] * (1 - added[3])) / mix[3]
                );
                // green
                mix[1] = Math.round(
                    (added[1] * added[3]) / mix[3] +
                    (base[1] * base[3] * (1 - added[3])) / mix[3]
                );
                // blue
                mix[2] = Math.round(
                    (added[2] * added[3]) / mix[3] +
                    (base[2] * base[3] * (1 - added[3])) / mix[3]
                );
            } else if (added) {
                mix = added;
            } else {
                mix = base;
            }
            base = mix;
        }
        return mix;
    }

    buildingColors(toutLesLayers) {

        //Suppression de la 4G inutile pour les batiments
        let layers = [];
        let coucheBatiments = 0;

        for (var i = toutLesLayers.length - 1; i >= 0; i--) {

            if (toutLesLayers[i].id !== "mobile_4g") {
                layers[coucheBatiments] = toutLesLayers[i];
                coucheBatiments++;
            }
        }

        if (layers[0].visibility + layers[1].visibility + layers[2].visibility === 1) {
            // Only on layers selected. Use opacity class
            const layer = layers.filter(obj => {
                return obj.visibility
            })[0];

            const result = ["case"];
            const opacities = [0.24, 0.46, 0.66, 0.78];
            for (let i = 0; i < 4; i++) {
                result.push(["==", ["number", ["get", "class_" + layer.id]], i + 1]);
                const color = this.blendColors([[240, 240, 240, 1], [...layer.color, opacities[i]]]);
                result.push("rgb(" + color.slice(0, 3).join(", ") + ")");
            }
            result.push("rgb(160, 160, 160)");
            return result;

        } else {
            // Multiple layers selected. Do not use opacity classes
            const result = ["case"];

            // Multiple layers selected. Do not use opacity classes
            for (let i = 0; i < 2 ** toutLesLayers.length; i++) {
                result.push(["==", ["number", ["get", "class"]], i]);
                const colors = [[255, 255, 255, 0.3]];
                for (let j = 0; j < toutLesLayers.length; j++) {
                    if (Math.trunc(i / 2 ** j) % 2 === 1 && toutLesLayers[j].visibility) {
                        colors.push([...toutLesLayers[j].color, .66]);
                    }
                }
                const color = this.blendColors(colors);
                result.push("rgb(" + color.slice(0, 3).join(", ") + ")");
            }
            result.push("rgb(255, 255, 255)");

            return result;
        }
    }

    handlePitch() {
        const currentZoom = this.map.getZoom();
        const currentPitch = this.map.getPitch();
        if (currentZoom > 13 && currentPitch !== pitch) {
            this.map.setPitch(pitch);
        } else if (currentZoom <= 13 && currentPitch !== 0) {
            this.map.setPitch(0);
        }
    }

    render() {
        return <CelesteMapContainer id="celeste-map"/>;
    }
}

export default CelesteMap;
